import React, { useState, useEffect } from "react";

import { Dropdown, DropdownMenu, DropdownToggle, FormGroup } from "reactstrap";

import { withTranslation } from "react-i18next";

import { isArray, sortArrayBy } from "../../Libs/CustomMethods/customMethods";
import { getOptions } from "../../Libs/CrudUtils/crudUtils";
import Select from "react-select";

import "./ListUsers.scss";

const ListUsers = ({ t, data }) => {
  const [sortedData, setSortedData] = useState([]);
  const [dropdown, setDropdown] = useState(false);

  const styles = {
    control: (base) => ({
      ...base,
      height: 35,
      marginBottom:
        55 +
        (sortedData.length < 7
          ? (sortedData.length - 1 >= 0 ? sortedData.length - 1 : 0) * 35
          : 210),
      minWidth: 300,
    }),
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "0.5rem",
        height: "0.5rem",
      },
      "::-webkit-scrollbar-track": {
        borderRadius: "0.5rem",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#a4a199",
        borderRadius: "0.5rem",
      },
    }),
  };

  const toggleDropdown = () => {
    setDropdown((prev) => !prev);
  };

  useEffect(() => {
    if (isArray(data)) {
      let aux = sortArrayBy(data, "name");
      setSortedData(aux);
    }
  }, [data]);

  return (
    <div>
      <Dropdown
        direction="left"
        className="list-user-dropdown"
        isOpen={dropdown}
        toggle={toggleDropdown}
      >
        <DropdownToggle className="list-user-toggle">
          <i className="text-dark bx bxs-user-detail font-size-18 px-2" />
        </DropdownToggle>
        <DropdownMenu>
          <FormGroup className="px-2 select2-container">
            <Select
              styles={styles}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
              }}
              classNamePrefix="select2-selection"
              placeholder={t("Search")}
              options={
                sortedData?.length > 0
                  ? getOptions(sortedData, false)
                  : getOptions(
                      {
                        id: 0,
                        name: "No matching records found",
                        isDisabled: true,
                      },
                      false
                    )
              }
              menuIsOpen={true}
              isSearchable={true}
              maxMenuHeight={250}
            />
          </FormGroup>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default withTranslation()(ListUsers);
